export default __webpack_public_path__ + "static/media/CartrLogo.91fca5ba.png";